export const RAVALEMENT_IMG =
  'https://images.pexels.com/photos/9784173/pexels-photo-9784173.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';
export const ITE_IMG =
  'https://images.pexels.com/photos/36574965/pexels-photo-36574965.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';
export const TCE_IMG =
  'https://images.pexels.com/photos/5691533/pexels-photo-5691533.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';
export const ETANCHEITE_IMG =
  'https://images.pexels.com/photos/39238328/pexels-photo-39238328.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';
export const COUVERTURE_IMG =
  'https://images.unsplash.com/photo-1602193230480-7840a38eb0c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600';
export const PARIS_IMG =
  'https://images.unsplash.com/photo-1614349214089-e969a07e033b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600';
